// Tiny shared flag (no heavy deps) — "this PC prints through the Windows RAW spooler" (Generic / Text Only driver)
const RAW_LS = 'sellox_raw_driver';
const RAW_LS_PRINTER = 'sellox_raw_printer';

export function rememberRawDriver(enabled, printerName, paperMm) {
  try {
    localStorage.setItem(RAW_LS, enabled ? '1' : '0');
    localStorage.setItem(RAW_LS_PRINTER, printerName || '');
    localStorage.setItem('sellox_raw_width', String(paperMm) === '58' ? '58' : '80');
  } catch { /* private mode */ }
}
export function rawDriverWanted() {
  try { return typeof window !== 'undefined' && !!window.selloxDesktop?.printRaw && localStorage.getItem(RAW_LS) === '1'; } catch { return false; }
}
export function rawPrinterName() { try { return localStorage.getItem(RAW_LS_PRINTER) || ''; } catch { return ''; } }
export function forgetRawPrinterName() { try { localStorage.setItem(RAW_LS_PRINTER, ''); } catch { /* ignore */ } }
